<template>
  <div class="mini-brand-card card-animation-on-hover">
    <router-link :to="routerLinkTo" class="mini-brand-card-link">
      <div class="card-content-wrapper">
        <img
          v-if="imageSrc"
          v-lazy="imageSrc"
          class="brand-logo"
          :alt="displayTitle"
          height="50px"
          width="50px"
        />
        <div class="brand-title-container">
          <p class="brand-title">
            {{ displayTitle }}
          </p>
          <hr class="section-divider">
          <small class="brand-text">
            {{  this.text }}
          </small>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'MiniBrandCard',
  props: {
    image: {
      type: String,
      default: ''
    },
    link: {
      type: [String, Object], // Can be a string path or a router-link object
      default: () => ({ path: '/' }) // Default to home if no link provided
    },
    title: {
      type: String,
      default: 'Brand Name' // Provide a sensible default
    },
    text: { // This prop was in the original script
      type: String,
      default: ''
    }
  },
  computed: {
    /**
     * Computes the image source for v-lazy directive.
     * @returns {string} The image URL with query parameters or an empty string.
     */
    imageSrc() {
      return this.image ? `${this.image}?q=&w=50&h=50&fit=clamp&monochrome=817373` : '';
    },
    /**
     * Provides a safe title for display, defaulting if the prop is not set.
     * @returns {string} The display title.
     */
    displayTitle() {
      return this.title || 'Untitled Brand';
    },
    /**
     * Ensures the router-link 'to' prop is always a valid object.
     * @returns {object|string} The value for :to prop.
     */
    routerLinkTo() {
      if (typeof this.link === 'string') {
        return { path: this.link };
      }
      return this.link || { path: '/' }; // Fallback to home
    }
  }
  // No methods were used in the original template snippet for this card's display logic.
};
</script>

